import { VStack, Skeleton, Button, Text, Box, Heading } from '@chakra-ui/react';
import { useTheme } from '../../contexts/ThemeProvider';
import { CardHistory } from './components/CardHistory';
import { FaFrown } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useSales } from '@/service/club/hooks';
import { MainTemplate } from '../../templates/MainTemplate';

export function OrderHistoryRoute() {
  return (
    <MainTemplate>
      <OrderHistoryPage />
    </MainTemplate>
  );
}

export function OrderHistoryPage() {
  const { colors, id } = useTheme();
  const { data, isFetching } = useSales(id || 0);
  const navigation = useNavigate();

  return (
    <Box
      width="100%"
      backgroundColor="white"
      padding={{ base: '18px', md: '20px' }}
      borderRadius="24px"
      boxShadow="4px 4px 10px 0px #0000002E"
    >
      <VStack align="stretch" spacing={4}>
        <Heading color="#292927" fontSize="18px" fontFamily="Glory" fontWeight={500}>
          Minhas compras
        </Heading>
        <Text color="#747474" fontSize="13px" fontFamily="Glory">
          Ingressos e vouchers pagos.
        </Text>

        {isFetching && (
          <VStack spacing={3} align="stretch">
            {new Array(4).fill(0).map((_, i) => (
              <Skeleton key={i} width="100%" borderRadius="12px" height="64px" />
            ))}
          </VStack>
        )}

        {!isFetching && data?.length === 0 && (
          <VStack spacing={4} py={6}>
            <FaFrown size="40px" color={colors.primaryColor} />
            <Text color="#747474" fontFamily="Glory" textAlign="center">
              Você ainda não possui compras.
            </Text>
            <Button
              borderColor={colors.primaryColor}
              variant="outline"
              color={colors.primaryColor}
              borderRadius="full"
              onClick={() => navigation('/vantagens')}
            >
              Ver vantagens
            </Button>
          </VStack>
        )}

        {!isFetching && data?.map((p) => <CardHistory key={p.id || p.code} {...p} />)}
      </VStack>
    </Box>
  );
}
